
import { EyeOutlined } from "@ant-design/icons";

const formatWpmScore = (value) => {
  if (value === null || value === undefined || value === "") return "--";
  const numeric = Number(value);
  if (Number.isNaN(numeric)) return value;
  return numeric.toFixed(3);
};

export const REJECTED_COLUMNS_HEAD = [
  {
    title: "Spec No.",
    dataIndex: "spec_concat",
    key: "spec_concat",
    align: "left",
    width: "130px",
  },
  {
    title: "Card No.",
    dataIndex: "card_no",
    key: "card_no",
    align: "left",
    width: "130px",
  },
  {
    title: "FEC",
    dataIndex: "fec",
    key: "fec",
    align: "center",
    width: "80px",
  },
  {
    title: "Description",
    dataIndex: "task_description",
    key: "task_description",
    align: "left",
  },
  {
    title: "Total Effort Hours",
    dataIndex: "total_effort_hours",
    key: "total_effort_hours",
    align: "center",
    width: "150px",
  },
  {
    title: "WPM Score",
    dataIndex: "wpm_score",
    key: "wpm_score",
    align: "center",
    width: "120px",
    render: (value) => formatWpmScore(value),
  },
  {
    title: "Spec Type",
    dataIndex: "spec_type",
    key: "spec_type",
    align: "left",
    width: "130px",
  },
];

export const COMPLETED_COLUMNS_HEAD = [
  {
    title: "Spec No.",
    dataIndex: "spec_concat",
    key: "spec_concat",
    align: "left",
    width: "130px",
  },
  {
    title: "Card No.",
    dataIndex: "card_no",
    key: "card_no",
    align: "left",
    width: "130px",
  },
  {
    title: "FEC",
    dataIndex: "fec",
    key: "fec",
    align: "center",
    width: "80px",
  },
  {
    title: "Description",
    dataIndex: "task_description",
    key: "task_description",
    align: "left",
  },
  {
    title: "Total Effort Hours",
    dataIndex: "total_effort_hours",
    key: "total_effort_hours",
    align: "center",
    width: "150px",
  },
  {
    title: "WPM Score",
    dataIndex: "wpm_score",
    key: "wpm_score",
    align: "center",
    width: "120px",
    render: (value) => formatWpmScore(value),
  },
  {
    title: "Spec Type",
    dataIndex: "spec_type",
    key: "spec_type",
    align: "left",
    width: "130px",
  },
];
export const getCompletedColumns = (onView) => [
  {
    title: "Spec No.",
    dataIndex: "spec_concat",
    key: "spec_concat",
    align: "left",
    width: "130px",
  },
  {
    title: "Card No.",
    dataIndex: "card_no",
    key: "card_no",
    align: "left",
    width: "130px",
  },
  {
    title: "FEC",
    dataIndex: "fec",
    key: "fec",
    align: "center",
    width: "80px",
  },
  {
    title: "Description",
    dataIndex: "task_description",
    key: "task_description",
    align: "left",
  },
  {
    title: "Total Effort Hours",
    dataIndex: "total_effort_hours",
    key: "total_effort_hours",
    align: "center",
    width: "150px",
  },
  {
    title: "WPM Score",
    dataIndex: "wpm_score",
    key: "wpm_score",
    align: "center",
    width: "120px",
    render: (value) => formatWpmScore(value),
  },
  {
    title: "Spec Type",
    dataIndex: "spec_type",
    key: "spec_type",
    align: "left",
    width: "130px",
  },
  {
    title: "",
    key: "view",
    dataIndex: "view",
    align: "center",
    width: "80px",
    render: (_, record) => (
      <EyeOutlined
        style={{ fontSize: "16px", color: "#737373", cursor: "pointer" }}
        onClick={() => onView?.(record)}
      />
    ),
  },
];
export const STYLES = {
  searchBard: {
    borderRadius: "8px",
    backgroundColor: "#EBEEF8",
    color: "#737373",
    display: "flex",
    marginTop: "5px",
  },
  tableTitle: {
    padding: "16px 0px",
    fontSize: "15px",
    fontWeight: 500,
    color: "#484950",
  },
};
